let initialState = {
	dispatchReports: [],
};

const DispatchReportsReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_DISPATCH_REPORTS':
			return {
				...state,
				dispatchReports: action.payload,
			};
		default:
			return state;
	}
};

export { DispatchReportsReducer };
